import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { ISendingItem, ISendingItemProps, ISendingItemStates } from "./interfaces";

export class SendingItem extends EntityManager<ISendingItem, ISendingItemProps, ISendingItemStates>{
    static initMetadata = (): IMetadata => {
        return {
            name: "SendingItem",
            title: "موارد ارسالی",
            Properties: [
                {
                    title: "نام",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 250,
                    rules: [{ required: true, message: 'لطفا نام را وارد نمایید' }]
                },
                {
                    title: "کد",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا کد را وارد نمایید' }]
                }
            ]
        };
    }
}